module.exports = __webpack_public_path__ + "static/media/user-navigator.66421750.svg";